import { render } from "./App.vue?vue&type=template&id=3bba093e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3bba093e&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.0_clean-css@5.3.3_c_96a688324025b4252ea2f1a72a246224/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__